// Module
var code = "<template bindable=\"product, packaging, volume\"> ${ product + ', ' + packaging + (volume ? ' - ' + volume + 'L fylling' : '' ) } </template> ";
// Exports
export default code;